<template>
  <div class="container">
      <el-form :model="inputForm" ref="inputForm" @submit.native.prevent class="el-form search-form" :class="{rightBorder: searchTabActive!=='Blending'}">
        <el-row>
          <el-col :span="12" style="padding-right: 40px;">
            <el-form-item prop="userInputModelName">
              <el-autocomplete
                class="inline-input userInputPJName"
                v-model="inputForm.userInputModelName"
                :fetch-suggestions="querySearch"
                :placeholder="$t('T_MODEL_SEARCH_TIPS')"
                :trigger-on-focus="false"
                @select="onModelSearch"
                clearable
                @keyup.enter.native="onModelSearch"
                style="width: 100%"
              >
                <el-button slot="append" :class="{searchIcon:!isPress, searchIconPress: isPress}"
                  @mousedown.native="isPress = true" @click="onModelSearch"  @mouseup.native="isPress = false">
                </el-button>
                <template slot-scope="{ item }">
                  <span>{{ getModelLabel(item.value) }}</span>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
            <el-form-item :label="$t('T_SEARCH_RESULT') + ':'" class="search-result-item">
              <span>{{ curvedMatchingModelData.length }}</span>
              <span v-if="curvedMatchingModelData.length === 1 || curvedMatchingModelData.length === 0">{{$t('T_RESULT')}}</span>
              <span v-else>{{$t('T_RESULTS')}}</span>
            </el-form-item>
            <el-form-item>
              <el-select style="width: 260px;" v-model="inputForm.selectedModel" @change="onModelChange">
                <el-option v-for="item in matchingModelDataSort" :key="item.value" :value="item.name" :label="getModelLabel(item.name)" />
              </el-select>
            </el-form-item>
        </el-row>
      </el-form>
  </div>
</template>

<script>
// import ProjectorSpec from '@/assets/data/projectorSpec.json'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'SearchProjectorTabByCurved',
  data () {
    return {
      inputForm: {
        userInputModelName: '',
        selectedModel: ''
      },
      userInput: '',
      isPress: false,
      selectOptions: [],
      curvedModelDataArr: [], // 支持的全部机种
      curvedMatchingModelData: [],
      curverSelectedModelData: '',
      selectedModelIndex: 0
    }
  },
  computed: {
    ...mapState([
      'searchMatchingModelData', 'searchSelectedModelData', 'searchMatchingLensID', 'searchSelectedLensData', 'matchingModelData', 'selectedModelData', 'searchTabActive', 'isSimple',
      'position', 'searchTabActive', 'fromBlending'
    ]),

    matchingModelDataSort () {
      return this.$commonJs.dataSort(this.curvedMatchingModelData, 'name')
    }
  },
  watch: {
    searchTabActive (val) {
      if ((val === 'CurvedSurface') && !this.fromBlending) {
        let exists = this.inputForm.userInputModelName ? this.curvedMatchingModelData.some(item => item.name.includes(this.inputForm.userInputModelName)) : false
        let lensData = this.findMatchingLensAndSelectedLensData(this.curvedMatchingModelData)
        this.setSpecificInfo(lensData)
        this.MATCHINGMODELDATA(this.curvedMatchingModelData)
        this.SELECTEDMODELDATA(this.curvedMatchingModelData[0])
        if (this.inputForm.userInputModelName && this.curverSelectedModelData.name !== this.inputForm.userInputModelName && exists) {
          this.onModelSearch()
        }
        this.MATCHINGLENSID(this.searchMatchingLensID)
        this.SELECTEDLENSDATA(this.searchSelectedLensData)
      }
    },

    selectedModelData (val, oldVal) {
      this.inputForm.selectedModel = val.name
    }
  },
  created () {
    // let lensData = this.findMatchingLensAndSelectedLensData(this.searchMatchingModelData)
    // this.setSpecificInfo(lensData)
  },
  methods: {
    ...mapMutations([
      'F_S2D',
      'F_D2S',
      'F_VOFFSET',
      'VLENSSHIFT',
      'HLENSSHIFT',
      'VHLENSSHIFT',
      'ASPECTRATIO',
      'SEARCHMATCHINGMODELDATA', 'SEARCHSELECTEDMODELDATA', 'SEARCHMATCHINGLENSID', 'SEARCHSELECTEDLENSDATA',
      'SET_VLENSSHIFT', 'SET_HLENSSHIFT', 'SET_OFFSET',
      'SET_HANGLEFLAG', 'SET_VANGLEFLAG', 'SET_SCREENSIZECHECKED', 'SET_THROWDISTANCECHECKED', 'SET_REALTHROWDISTANCECHECKED', 'ROOMW', 'ROOMD', 'ROOMH',
      'MATCHINGMODELDATA', 'SELECTEDMODELDATA', 'MATCHINGLENSID', 'SELECTEDLENSDATA', 'SET_TEMVLENSSHIFT', 'SET_ISSIMPLE', 'SET_POSITION', 'SET_TABACTIVENAME',
      'SET_ISUSTWALL',
      'SET_OUTOFSPECVAL',
      'SET_ISOUTOFSPEC',
      'SET_WHITEBOARDSTATUS'
    ]),

    querySearch (queryString, cb) {
      var results = queryString ? this.curvedMatchingModelData.filter(this.createFilter(queryString)) : this.curvedMatchingModelData
      // 调用 callback 返回建议列表的数据
      results.sort((obj1, obj2) => {
        return obj1.name.localeCompare(obj2.name)
      })
      cb(results)
    },

    createFilter (queryString) {
      return (dataOptions) => {
        dataOptions.value = dataOptions.name
        let label = this.getModelLabel(dataOptions.name)
        return (label.toLowerCase().indexOf(queryString.toLowerCase()) > -1)
      }
    },
    setSelectedPJModel (value) {
      this.selectedModelIndex = 0
      this.SEARCHMATCHINGMODELDATA([value])
      this.SEARCHSELECTEDMODELDATA(value)
      this.MATCHINGMODELDATA([value])
      this.SELECTEDMODELDATA(value)
      this.findMatchingLensAndSelectedLensData([value])
      this.SET_WHITEBOARDSTATUS(false)
      // 统一到simpleViewIndex.vue中处理
      // if (this.isSimple && (value.category === 4 || value.category === 5) && value.position === 2) {
      //   this.$commonJs.SimpleDisable()
      //   this.$router.push('/page/advanceMode')
      //   this.SET_ISSIMPLE(false)
      //   this.SET_TABACTIVENAME('Advanced')
      //   this.SET_POSITION(2)
      // }
    },
    onModelSearch (event) {
      // GA追加：入力框检索(回车，放大镜，选择之后触发(只针对「曲面スクリーン」tab))this.$t('T_SEARCH_MODEL')
      sessionStorage.setItem('search_m_model', this.getModelLabel(this.inputForm.userInputModelName))
      // GA追加：入力框检索(回车，放大镜，选择之后触发(只针对「曲面スクリーン」tab))
      this.userInput = this.inputForm.userInputModelName
      this.inputForm.userInputModelName = this.getModelLabel(this.userInput)
      this.findMatchingModel()
      this.SET_WHITEBOARDSTATUS(false)
      // 统一到simpleViewIndex.vue中处理
      // if (this.isSimple && (this.selectedModelData.category === 4 || this.selectedModelData.category === 5) && this.position === 2) {
      //   this.$commonJs.SimpleDisable()
      //   this.$router.push('/page/advanceMode')
      //   this.SET_ISSIMPLE(false)
      //   this.SET_TABACTIVENAME('Advanced')
      //   this.SET_POSITION(2)
      // }
    },
    findMatchingModel () {
      let matchModelArr = []
      let userInputModelName = this.inputForm.userInputModelName.toLowerCase()
      let isSame = false
      this.selectedModelIndex = 0
      this.curvedModelDataArr.filter(item => {
        let pjName = this.getModelLabel(item.name).toLowerCase()
        if (pjName.indexOf(userInputModelName) !== -1) {
          matchModelArr.push(item)
        }
        if (pjName === userInputModelName) {
          isSame = true
        }
      })
      matchModelArr = this.$commonJs.dataSort(matchModelArr, 'name')
      if (isSame) {
        this.selectedModelIndex = matchModelArr.findIndex((item) => this.getModelLabel(item.name).toLowerCase() === userInputModelName)
      }
      if (matchModelArr.length > 0) {
        this.setModeldata(matchModelArr)
        this.findMatchingLensAndSelectedLensData(matchModelArr)
      } else {
        if (document.getElementsByClassName('el-message').length === 0) {
          this.$message.warning({
            message: this.$t('T_NO_RESULT'),
            duration: 3000
          })
        }
      }
    },
    setModeldata (value) {
      this.curvedMatchingModelData = value
      this.curvedSelectedModelData = value[this.selectedModelIndex]
      // this.SEARCHMATCHINGMODELDATA(value)
      // this.SEARCHSELECTEDMODELDATA(value[this.selectedModelIndex])
      this.MATCHINGMODELDATA(value)
      this.SELECTEDMODELDATA(value[this.selectedModelIndex])
    },
    setLensData (idArr, data) {
      this.SEARCHMATCHINGLENSID(idArr)
      this.SEARCHSELECTEDLENSDATA(data)
      this.MATCHINGLENSID(idArr)
      this.SELECTEDLENSDATA(data)
    },
    findMatchingLensAndSelectedLensData (modelArr) {
      let selectedModelData = modelArr[this.selectedModelIndex]
      let lensInfo = this.$commonJs.findLensInfo(selectedModelData)
      this.setLensData(lensInfo.matchingLensID, lensInfo.selectedLensInfo)
      return lensInfo.selectedLensInfo
    },
    setSpecificInfo (data) {
      let defaultRatio = data.lcd.aspectRatio
      let defaultDistInfo = data.lcd.distInfo.find(
        item => item.ratio === defaultRatio
      )
      this.F_S2D(defaultDistInfo.size2dist)
      this.F_D2S(defaultDistInfo.dist2size)
      this.F_VOFFSET(defaultDistInfo.screenSizeToVOffset)

      this.VLENSSHIFT(data.lcd.lensShiftRange.v)
      this.SET_TEMVLENSSHIFT(data.lcd.lensShiftRange.v)
      this.HLENSSHIFT(data.lcd.lensShiftRange.h)
      this.VHLENSSHIFT(data.lcd.lensShiftRange.hv)
      this.ASPECTRATIO(data.lcd.aspectRatio)
    },

    // 投影仪切换
    onModelChange (value) {
      this.setSelectedModelData(value)
      this.findMatchingLensAndSelectedLensData([this.curverSelectedModelData])
    },

    setSelectedModelData (value) {
      this.curverSelectedModelData = this.curvedMatchingModelData.find(
        item => item.name === value
      )
      this.SELECTEDMODELDATA(this.curverSelectedModelData)
      this.SEARCHSELECTEDMODELDATA(this.curverSelectedModelData)
    },
    init (val, oldVal) {
      let modelDataArr = []
      modelDataArr = this.ProjectorSpec.filter((item) => { return item.curvedSurface === true || item.curvedCorrection === true })
      this.curvedModelDataArr = JSON.parse(JSON.stringify(modelDataArr))
      this.curvedMatchingModelData = JSON.parse(JSON.stringify(modelDataArr))
      this.curverSelectedModelData = this.curvedMatchingModelData[0]
      this.inputForm.selectedModel = this.curverSelectedModelData.name
      this.selectedModelIndex = this.curvedMatchingModelData.findIndex(
        item => item.name === this.curverSelectedModelData.name
      )
    },
    getModelLabel (label) {
      return this.$commonJs.getModelLabelByName(label)
    }
  },
  mounted () {
    this.init()
  }

}
</script>

<style scoped>
.searchIcon {
  background: url('~@/assets/parts/icon/TDC_search.png') no-repeat center;
}

.searchIconPress {
  background: url('~@/assets/parts/icon/TDC_search.png') no-repeat center;
}
.rightBorder{
  border-right: 2px solid #bdbdbd;
}
</style>



// WEBPACK FOOTER //
// src/view/searchTabs/tabs/searchProjectorTabByCurved.vue